import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";

import Loading from "../../common/Loading";

import { CALL_DETAIL_COLUMNS } from "./columns";

const CallDetailList = ({
  data,
  loading,
  onPageSizeChange,
  defaultPageSize,
  onPageChange,
  page,
  pageSize,
  count
}) => {
  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        manual
        showPageSizeOptions
        showPagination
        className="-highlight calls"
        columns={CALL_DETAIL_COLUMNS}
        data={data}
        defaultPageSize={defaultPageSize}
        noDataText="No calls found"
        pageSize={Math.min(pageSize)}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        pages={Math.ceil(count / pageSize)}
        page={page}
      />
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};
CallDetailList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  defaultPageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPageSizeChange: PropTypes.func,
  onPageChange: PropTypes.func,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.number
};
export default CallDetailList;
